// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-dark: #1A1A1A;
    --bg-darker: #0f0f10;
    --text: #f2f2f2;
    --muted: #cfcfcf;
    --accent: #E63946;
    --accent-2: #C71C2B;
    --grad-darkred: linear-gradient(135deg,
            #0f0f10,
            #1A1A1A,
            #2a2a2a,
            #8B0000,
            #C71C2B);
    --shadow: 0 10px 30px rgba(0, 0, 0, .25);
}

*,
*::before,
*::after {
    box-sizing: border-box;
}

html,
body {
 margin: 0;
  padding: 0;
  min-height: 100vh;

  font-family: 'Segoe UI', Tahoma, Arial, sans-serif;
  color: var(--text);
  scroll-behavior: smooth;

  background: var(--grad-darkred);
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 400% 400%;          /* important */
  animation: gradientAnim 12s ease infinite;

}

/* Sidebar */
.sidebar {
    position: fixed;
    top: 0;
    right: 0;
    height: 100vh;
    width: 260px;
    background: var(--grad-darkred);
    background-size: 400% 400%;
    animation: gradientAnim 12s ease infinite;
    display: flex;
    flex-direction: column;
    padding: 40px 24px;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.4);
    z-index: 1000;
}

/* Le contenu principal réserve la place de la sidebar sur écran large */
.main-content {
    width: calc(100% - 260px);
    min-width: 0;
    overflow-x: hidden;
}

/* Logo */
.sidebar .brand {
    margin-bottom: 40px;
}

.sidebar .brand h1 {
    margin: 0;
    font-weight: 800;
    color: var(--accent);
    letter-spacing: 1px;
    white-space: nowrap;
    font-size: clamp(1rem, 1.6vw, 1.4rem);
}

.logo-link {
    text-decoration: none;
    color: var(--accent);
    display: inline-block;
}

.logo-link:hover {
    color: var(--accent-2);
    text-decoration: none;
}

/* Nav */
.nav-menu {
    display: flex;
    flex-direction: column;
    gap: 22px;
}

.nav-menu a {
    color: #fff;
    text-decoration: none;
    font-weight: 600;
    font-size: 1.05rem;
    padding: 10px 14px;
    border-radius: 8px;
    transition: all .25s ease;
}

.nav-menu a:hover {
    background: rgba(255, 255, 255, 0.1);
    color: var(--accent);
    transform: translateX(-6px);
}

/* Burger */
.burger {
    display: none;
    position: fixed;
    top: 16px;
    left: 16px;
    width: 38px;
    height: 38px;
    background: transparent;
    border: none;
    cursor: pointer;
    z-index: 1100;
}

.burger .line {
    position: absolute;
    left: 9px;
    right: 9px;
    height: 3px;
    background: #fff;
    border-radius: 3px;
    transition: transform .25s, top .25s, opacity .2s;
}

.burger .line:nth-child(1) {
    top: 11px;
}

.burger .line:nth-child(2) {
    top: 18px;
}

.burger .line:nth-child(3) {
    top: 25px;
}

.burger.active .line:nth-child(1) {
    top: 18px;
    transform: rotate(45deg);
}

.burger.active .line:nth-child(2) {
    opacity: 0;
}

.burger.active .line:nth-child(3) {
    top: 18px;
    transform: rotate(-45deg);
}


/* Ajouts spécifiques */ .tech-logos { margin-top: 28px; display: grid; grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)); gap: 28px; align-items: center; justify-items: center; } .tech-logos img { width: 80px; /* case fixe */ height: 50px; /* case fixe */ object-fit: contain;/* garde les proportions */ background: #fff; /* optionnel : fond blanc pour homogénéiser */ padding: 8px; /* petit espace autour */ border-radius: 10px;/* coins arrondis */ filter: grayscale(100%) brightness(0.8); transition: all .25s ease; } .tech-logos img:hover { filter: grayscale(0%) brightness(1); transform: scale(1.05); } .see-more { margin: 32px auto 0; display: block; padding: 12px 22px; border-radius: 8px; border: none; font-weight: 600; background: var(--accent); color: #fff; cursor: pointer; transition: all .25s; } .see-more:hover { background: var(--accent-2); transform: translateY(-2px); }
/* Responsive */
@media (max-width: 1100px) {
    .main-content {
        width: 100%;
    }

    .sidebar {
        transform: translateX(100%);
        transition: transform .3s ease;
    }

    .sidebar.open {
        transform: translateX(0);
    }

    .burger {
        display: block;
    }
}

/* Sections */
section {
    max-width: 1120px;
    margin: 0 auto;
    padding: 88px 20px;
    border-radius: 14px;
    scroll-margin-top: 88px;
}

h2.section-title {
    text-align: center;
    font-size: clamp(24px, 3.5vw, 36px);
    margin: 0 0 22px 0;
}

.section-sub {
    text-align: center;
    color: var(--muted);
    max-width: 820px;
    margin: 0 auto 42px auto;
}

/* Hero */
.hero {
    height: 92vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 20px;
    background: var(--grad-darkred);
    background-size: 400% 400%;
    animation: gradientAnim 12s ease infinite;
    position: relative;
    overflow: hidden;
}

.typing {
    font-size: clamp(28px, 5vw, 56px);
    font-weight: 800;
    margin: 0 0 12px 0;
}

.cursor {
    display: inline-block;
    margin-left: 2px;
    color: var(--accent);
    animation: blink .8s infinite;
}

.hero p {
    max-width: 820px;
    color: #ededed;
    margin: 8px auto 28px;
}

.cta {
    border: none;
    background: var(--accent);
    color: #fff;
    padding: 14px 24px;
    border-radius: 10px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 10px 30px rgba(230, 57, 70, .35);
    transition: transform .18s, background .25s, box-shadow .25s;
}

.cta:hover {
    background: var(--accent-2);
    transform: translateY(-2px);
    box-shadow: 0 14px 40px rgba(230, 57, 70, .45);
}

/* Particules */
.particles span {
    position: absolute;
    bottom: -60px;
    background: rgba(230, 57, 70, .7);
    border-radius: 50%;
    filter: blur(.5px);
    animation: rise linear infinite;
}

.particles span:nth-child(1) {
    left: 18%;
    width: 14px;
    height: 14px;
    animation-duration: 10s
}

.particles span:nth-child(2) {
    left: 34%;
    width: 10px;
    height: 10px;
    animation-duration: 13s
}

.particles span:nth-child(3) {
    left: 56%;
    width: 22px;
    height: 22px;
    animation-duration: 16s
}

.particles span:nth-child(4) {
    left: 76%;
    width: 12px;
    height: 12px;
    animation-duration: 12s
}

.particles span:nth-child(5) {
    left: 12%;
    width: 18px;
    height: 18px;
    animation-duration: 14s
}

.particles span:nth-child(6) {
    left: 88%;
    width: 8px;
    height: 8px;
    animation-duration: 11s
}

/* About */
#about {
    background: #1f1f1f;
    color: var(--text);
}

/* Services */
#services {
    background: var(--grad-darkred);
    background-size: 400% 400%;
    animation: gradientAnim 12s ease infinite;
    color: var(--text);
}

.cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 22px;
}

.card {
    background: #2a2a2a;
    color: #fff;
    border-radius: 14px;
    padding: 24px;
    box-shadow: var(--shadow);
    transition: transform .3s, box-shadow .3s;
}

.card:hover {
    transform: translateY(-6px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, .28);
}

/* Portfolio */
#portfolio {
    background: linear-gradient(135deg, var(--bg-dark), var(--bg-darker));
    color: var(--text);
}


/* Contact */
#contact {
    background: var(--grad-darkred);
    background-size: 400% 400%;
    animation: gradientAnim 12s ease infinite;
    color: var(--text);
}

form {
    background: #2a2a2a;
    border-radius: 16px;
    box-shadow: var(--shadow);
    padding: 32px;
    max-width: 720px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
/* Réalisation en pleine largeur */
.portfolio-heading {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 28px;
}

.portfolio-heading .section-title {
    margin-bottom: 8px;
    text-align: left;
}

.portfolio-heading .section-sub {
    margin: 0;
    text-align: left;
}

.carousel-actions {
    display: flex;
    gap: 10px;
}

.carousel-button {
    width: 48px;
    height: 48px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    font-size: 22px;
    cursor: pointer;
    transition: 0.25s ease;
}

.carousel-button:hover {
    background: var(--accent);
    border-color: var(--accent);
    transform: translateY(-2px);
}

.project-page {
    position: relative;
    width: 100%;
    height: 520px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 20px;
    background: #111;
    box-shadow: var(--shadow);
    transform-origin: right center;
    animation: turnProjectPage 0.9s ease both;
}

.project-page a {
    display: block;
    width: 100%;
    height: 100%;
}

.project-page img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center top;
    background: #111;
}

.project-page-overlay {
    position: absolute;
    inset: 0;
    z-index: 2;
    display: flex;
    align-items: flex-end;
    padding: 36px;
    color: #fff;
    background: linear-gradient(
        0deg,
        rgba(0, 0, 0, 0.96) 0%,
        rgba(0, 0, 0, 0.55) 35%,
        transparent 70%
    );
}

.project-counter {
    position: absolute;
    top: 24px;
    right: 26px;
    padding: 8px 13px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.7);
    font-size: 13px;
    font-weight: 700;
}

.project-page-content {
    width: min(520px, 90%);
}

.project-page-content h3 {
    margin: 0 0 12px;
    color: #fff;
    font-size: clamp(30px, 5vw, 52px);
    line-height: 1.1;
}

.project-page-content p {
    margin: 0 0 20px;
    color: rgba(255, 255, 255, 0.85);
    font-size: 17px;
    line-height: 1.55;
}

.project-link {
    font-size: 14px;
    font-weight: 700;
    color: var(--accent);
}

.project-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 22px;
}

.project-dots button {
    width: 10px;
    height: 10px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    cursor: pointer;
    transition: 0.25s ease;
}

.project-dots button.active {
    width: 30px;
    border-radius: 10px;
    background: var(--accent);
}

@keyframes turnProjectPage {
    from {
        opacity: 0;
        transform: perspective(1400px) rotateY(18deg) translateX(-45px);
        filter: brightness(0.5);
    }

    to {
        opacity: 1;
        transform: perspective(1400px) rotateY(0) translateX(0);
        filter: brightness(1);
    }
}

@media (max-width: 640px) {
    .portfolio-heading {
        align-items: center;
    }

    .carousel-actions {
        display: none;
    }

    .project-page {
        height: 460px;
    }

    .project-page-overlay {
        padding: 24px;
    }

    .project-page-content h3 {
        font-size: 30px;
    }

    .project-page-content p {
        font-size: 15px;
    }
}
.grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 18px;
}

@media (max-width:640px) {
    .grid-2 {
        grid-template-columns: 1fr
    }
}

.form-field {
    position: relative;
    display: flex;
    flex-direction: column;
}

.form-field input,
.form-field textarea {
    width: 100%;
    padding: 14px 14px;
    border-radius: 10px;
    background: #1a1a1a;
    color: #fff;
    border: 2px solid #333;
    outline: none;
    transition: border-color .25s, box-shadow .25s;
}

.form-field input:focus,
.form-field textarea:focus {
    border-color: var(--accent);
    box-shadow: 0 0 12px rgba(230, 57, 70, .35);
}

.form-field label {
    position: absolute;
    left: 12px;
    top: 12px;
    font-size: 14px;
    color: #aaa;
    pointer-events: none;
    transition: all .18s ease;
    background: #2a2a2a;
    padding: 0 6px;
    border-radius: 6px;
}

.form-field input:focus+label,
.form-field input:not(:placeholder-shown)+label,
.form-field textarea:focus+label,
.form-field textarea:not(:placeholder-shown)+label {
    top: -10px;
    left: 8px;
    font-size: 12px;
    color: var(--accent);
}

.submit {
    background: var(--accent);
    color: #fff;
    border: none;
    padding: 16px;
    border-radius: 12px;
    font-weight: 700;
    font-size: 16px;
    cursor: pointer;
    box-shadow: 0 10px 28px rgba(230, 57, 70, .35);
    transition: transform .18s, background .25s, box-shadow .25s;
}

.submit:hover {
    background: var(--accent-2);
    transform: translateY(-2px);
    box-shadow: 0 14px 40px rgba(230, 57, 70, .45);
}

.status {
    text-align: center;
    margin-top: 4px;
    font-weight: 700;
}

/* Reveal */
.reveal {
    opacity: 0;
    transform: translateY(26px) scale(.98);
    transition: opacity .8s, transform .8s;
}

.reveal.visible {
    opacity: 1;
    transform: translateY(0) scale(1);
}

/* Footer */
footer {
    margin-top: 64px;
    background: var(--bg-dark);
    color: var(--text);
    text-align: center;
    padding: 28px 20px;
    border-top: 1px solid rgba(255, 255, 255, .06);
    border-radius: 14px;
}

.footer-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 40px;
    max-width: 1200px;
    margin: 0 auto;
}

.contact-btn {
    display: inline-block;
    background: transparent;
    color: var(--accent);
    text-decoration: none;
    font-weight: 700;
    font-size: 16px;
    padding: 14px 22px;
    border: 2px solid var(--accent);
    border-radius: 50px;
    transition: all .3s ease;
    margin-bottom: 16px;
}

.contact-btn:hover {
    background: var(--accent);
    color: #fff;
    transform: translateY(-3px);
    box-shadow: 0 6px 16px rgba(230, 57, 70, 0.4);
}

.footer-container h4 {
    color: var(--accent);
    margin-bottom: 12px;
}

.footer-nav ul {
    list-style: none;
    padding: 0;
}

.footer-nav li {
    margin: 6px 0;
}

.footer-nav a,
.footer-social a {
    color: #f2f2f2;
    text-decoration: none;
    transition: color .2s;
}

.footer-nav a:hover,
.footer-social a:hover {
    color: var(--accent);
}

.footer-bottom {
    text-align: center;
    margin-top: 40px;
    font-size: 0.9rem;
    color: #aaa;
}

.footer-bottom a {
    color: var(--accent);
    text-decoration: none;
}

.footer-bottom a:hover {
    text-decoration: underline;
}

.footer-social {
    text-align: center;
}

.social-icons {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin: 10px 0 20px;
}

.social-icons a {
    color: var(--accent);
    font-size: 28px;
    transition: transform .2s, color .3s;
}

.social-icons a:hover {
    color: var(--accent-2);
    transform: scale(1.2);
}

.social-icons svg {
    width: 28px;
    height: 28px;
}

/* Animations */
@keyframes gradientAnim {
    0% {
        background-position: 0% 50%
    }

    50% {
        background-position: 100% 50%
    }

    100% {
        background-position: 0% 50%
    }
}

@keyframes blink {

    0%,
    50% {
        opacity: 1
    }

    50.01%,
    100% {
        opacity: 0
    }
}

@keyframes rise {
    from {
        transform: translateY(0) scale(1);
        opacity: 1
    }

    to {
        transform: translateY(-100vh) scale(.5);
        opacity: 0
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/WolframHartSite.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB;;;;;oBAKgB;IAChB,wCAAwC;AAC5C;;AAEA;;;IAGI,sBAAsB;AAC1B;;AAEA;;CAEC,SAAS;EACR,UAAU;EACV,iBAAiB;;EAEjB,kDAAkD;EAClD,kBAAkB;EAClB,uBAAuB;;EAEvB,+BAA+B;EAC/B,4BAA4B;EAC5B,4BAA4B;EAC5B,0BAA0B,WAAW,cAAc;EACnD,yCAAyC;;AAE3C;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,+BAA+B;IAC/B,0BAA0B;IAC1B,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;AACjB;;AAEA,wEAAwE;AACxE;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,QAAQ;AACR;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA,WAAW;AACX;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;IACT,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,SAAS;IACT,yBAAyB;AAC7B;;;AAGA,uBAAuB,EAAE,cAAc,gBAAgB,EAAE,aAAa,EAAE,0DAA0D,EAAE,SAAS,EAAE,mBAAmB,EAAE,qBAAqB,EAAE,EAAE,kBAAkB,WAAW,EAAE,cAAc,EAAE,YAAY,EAAE,cAAc,EAAE,mBAAmB,CAAC,0BAA0B,EAAE,gBAAgB,EAAE,6CAA6C,EAAE,YAAY,EAAE,wBAAwB,EAAE,mBAAmB,CAAC,mBAAmB,EAAE,uCAAuC,EAAE,yBAAyB,EAAE,EAAE,wBAAwB,mCAAmC,EAAE,sBAAsB,EAAE,EAAE,YAAY,mBAAmB,EAAE,cAAc,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,YAAY,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,WAAW,EAAE,eAAe,EAAE,oBAAoB,EAAE,EAAE,kBAAkB,2BAA2B,EAAE,2BAA2B,EAAE;AAC/3B,eAAe;AACf;IACI;QACI,WAAW;IACf;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA,SAAS;AACT;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,0BAA0B;IAC1B,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,SAAS;IACT,UAAU;IACV,WAAW;IACX;AACJ;;AAEA,UAAU;AACV;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,aAAa;AACb;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,cAAc;AACd;IACI,qEAAqE;IACrE,kBAAkB;AACtB;;;AAGA,YAAY;AACZ;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;AACA,kCAAkC;AAClC;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,0CAA0C;IAC1C,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,eAAe;IACf,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,2CAA2C;IAC3C,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,WAAW;IACX;;;;;KAKC;AACL;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,2CAA2C;IAC3C,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI;QACI,UAAU;QACV,+DAA+D;QAC/D,uBAAuB;IAC3B;;IAEA;QACI,UAAU;QACV,uDAAuD;QACvD,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,aAAa;IACb,8CAA8C;AAClD;;AAEA;;IAEI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;;;IAII,UAAU;IACV,SAAS;IACT,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,8CAA8C;IAC9C,4DAA4D;AAChE;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA,WAAW;AACX;IACI,UAAU;IACV,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,UAAU;IACV,iCAAiC;AACrC;;AAEA,WAAW;AACX;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,8CAA8C;IAC9C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,+BAA+B;IAC/B,mBAAmB;IACnB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;;IAEI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,eAAe;AACf;IACI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;AACJ;;AAEA;;IAEI;;QAEI;IACJ;;IAEA;;QAEI;IACJ;AACJ;;AAEA;IACI;QACI,iCAAiC;QACjC;IACJ;;IAEA;QACI,uCAAuC;QACvC;IACJ;AACJ","sourcesContent":[":root {\n    --bg-dark: #1A1A1A;\n    --bg-darker: #0f0f10;\n    --text: #f2f2f2;\n    --muted: #cfcfcf;\n    --accent: #E63946;\n    --accent-2: #C71C2B;\n    --grad-darkred: linear-gradient(135deg,\n            #0f0f10,\n            #1A1A1A,\n            #2a2a2a,\n            #8B0000,\n            #C71C2B);\n    --shadow: 0 10px 30px rgba(0, 0, 0, .25);\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n margin: 0;\n  padding: 0;\n  min-height: 100vh;\n\n  font-family: 'Segoe UI', Tahoma, Arial, sans-serif;\n  color: var(--text);\n  scroll-behavior: smooth;\n\n  background: var(--grad-darkred);\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-size: 400% 400%;          /* important */\n  animation: gradientAnim 12s ease infinite;\n\n}\n\n/* Sidebar */\n.sidebar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    height: 100vh;\n    width: 260px;\n    background: var(--grad-darkred);\n    background-size: 400% 400%;\n    animation: gradientAnim 12s ease infinite;\n    display: flex;\n    flex-direction: column;\n    padding: 40px 24px;\n    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.4);\n    z-index: 1000;\n}\n\n/* Le contenu principal réserve la place de la sidebar sur écran large */\n.main-content {\n    width: calc(100% - 260px);\n    min-width: 0;\n    overflow-x: hidden;\n}\n\n/* Logo */\n.sidebar .brand {\n    margin-bottom: 40px;\n}\n\n.sidebar .brand h1 {\n    margin: 0;\n    font-weight: 800;\n    color: var(--accent);\n    letter-spacing: 1px;\n    white-space: nowrap;\n    font-size: clamp(1rem, 1.6vw, 1.4rem);\n}\n\n.logo-link {\n    text-decoration: none;\n    color: var(--accent);\n    display: inline-block;\n}\n\n.logo-link:hover {\n    color: var(--accent-2);\n    text-decoration: none;\n}\n\n/* Nav */\n.nav-menu {\n    display: flex;\n    flex-direction: column;\n    gap: 22px;\n}\n\n.nav-menu a {\n    color: #fff;\n    text-decoration: none;\n    font-weight: 600;\n    font-size: 1.05rem;\n    padding: 10px 14px;\n    border-radius: 8px;\n    transition: all .25s ease;\n}\n\n.nav-menu a:hover {\n    background: rgba(255, 255, 255, 0.1);\n    color: var(--accent);\n    transform: translateX(-6px);\n}\n\n/* Burger */\n.burger {\n    display: none;\n    position: fixed;\n    top: 16px;\n    left: 16px;\n    width: 38px;\n    height: 38px;\n    background: transparent;\n    border: none;\n    cursor: pointer;\n    z-index: 1100;\n}\n\n.burger .line {\n    position: absolute;\n    left: 9px;\n    right: 9px;\n    height: 3px;\n    background: #fff;\n    border-radius: 3px;\n    transition: transform .25s, top .25s, opacity .2s;\n}\n\n.burger .line:nth-child(1) {\n    top: 11px;\n}\n\n.burger .line:nth-child(2) {\n    top: 18px;\n}\n\n.burger .line:nth-child(3) {\n    top: 25px;\n}\n\n.burger.active .line:nth-child(1) {\n    top: 18px;\n    transform: rotate(45deg);\n}\n\n.burger.active .line:nth-child(2) {\n    opacity: 0;\n}\n\n.burger.active .line:nth-child(3) {\n    top: 18px;\n    transform: rotate(-45deg);\n}\n\n\n/* Ajouts spécifiques */ .tech-logos { margin-top: 28px; display: grid; grid-template-columns: repeat(auto-fit, minmax(80px, 1fr)); gap: 28px; align-items: center; justify-items: center; } .tech-logos img { width: 80px; /* case fixe */ height: 50px; /* case fixe */ object-fit: contain;/* garde les proportions */ background: #fff; /* optionnel : fond blanc pour homogénéiser */ padding: 8px; /* petit espace autour */ border-radius: 10px;/* coins arrondis */ filter: grayscale(100%) brightness(0.8); transition: all .25s ease; } .tech-logos img:hover { filter: grayscale(0%) brightness(1); transform: scale(1.05); } .see-more { margin: 32px auto 0; display: block; padding: 12px 22px; border-radius: 8px; border: none; font-weight: 600; background: var(--accent); color: #fff; cursor: pointer; transition: all .25s; } .see-more:hover { background: var(--accent-2); transform: translateY(-2px); }\n/* Responsive */\n@media (max-width: 1100px) {\n    .main-content {\n        width: 100%;\n    }\n\n    .sidebar {\n        transform: translateX(100%);\n        transition: transform .3s ease;\n    }\n\n    .sidebar.open {\n        transform: translateX(0);\n    }\n\n    .burger {\n        display: block;\n    }\n}\n\n/* Sections */\nsection {\n    max-width: 1120px;\n    margin: 0 auto;\n    padding: 88px 20px;\n    border-radius: 14px;\n    scroll-margin-top: 88px;\n}\n\nh2.section-title {\n    text-align: center;\n    font-size: clamp(24px, 3.5vw, 36px);\n    margin: 0 0 22px 0;\n}\n\n.section-sub {\n    text-align: center;\n    color: var(--muted);\n    max-width: 820px;\n    margin: 0 auto 42px auto;\n}\n\n/* Hero */\n.hero {\n    height: 92vh;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 0 20px;\n    background: var(--grad-darkred);\n    background-size: 400% 400%;\n    animation: gradientAnim 12s ease infinite;\n    position: relative;\n    overflow: hidden;\n}\n\n.typing {\n    font-size: clamp(28px, 5vw, 56px);\n    font-weight: 800;\n    margin: 0 0 12px 0;\n}\n\n.cursor {\n    display: inline-block;\n    margin-left: 2px;\n    color: var(--accent);\n    animation: blink .8s infinite;\n}\n\n.hero p {\n    max-width: 820px;\n    color: #ededed;\n    margin: 8px auto 28px;\n}\n\n.cta {\n    border: none;\n    background: var(--accent);\n    color: #fff;\n    padding: 14px 24px;\n    border-radius: 10px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: 0 10px 30px rgba(230, 57, 70, .35);\n    transition: transform .18s, background .25s, box-shadow .25s;\n}\n\n.cta:hover {\n    background: var(--accent-2);\n    transform: translateY(-2px);\n    box-shadow: 0 14px 40px rgba(230, 57, 70, .45);\n}\n\n/* Particules */\n.particles span {\n    position: absolute;\n    bottom: -60px;\n    background: rgba(230, 57, 70, .7);\n    border-radius: 50%;\n    filter: blur(.5px);\n    animation: rise linear infinite;\n}\n\n.particles span:nth-child(1) {\n    left: 18%;\n    width: 14px;\n    height: 14px;\n    animation-duration: 10s\n}\n\n.particles span:nth-child(2) {\n    left: 34%;\n    width: 10px;\n    height: 10px;\n    animation-duration: 13s\n}\n\n.particles span:nth-child(3) {\n    left: 56%;\n    width: 22px;\n    height: 22px;\n    animation-duration: 16s\n}\n\n.particles span:nth-child(4) {\n    left: 76%;\n    width: 12px;\n    height: 12px;\n    animation-duration: 12s\n}\n\n.particles span:nth-child(5) {\n    left: 12%;\n    width: 18px;\n    height: 18px;\n    animation-duration: 14s\n}\n\n.particles span:nth-child(6) {\n    left: 88%;\n    width: 8px;\n    height: 8px;\n    animation-duration: 11s\n}\n\n/* About */\n#about {\n    background: #1f1f1f;\n    color: var(--text);\n}\n\n/* Services */\n#services {\n    background: var(--grad-darkred);\n    background-size: 400% 400%;\n    animation: gradientAnim 12s ease infinite;\n    color: var(--text);\n}\n\n.cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 22px;\n}\n\n.card {\n    background: #2a2a2a;\n    color: #fff;\n    border-radius: 14px;\n    padding: 24px;\n    box-shadow: var(--shadow);\n    transition: transform .3s, box-shadow .3s;\n}\n\n.card:hover {\n    transform: translateY(-6px);\n    box-shadow: 0 18px 40px rgba(0, 0, 0, .28);\n}\n\n/* Portfolio */\n#portfolio {\n    background: linear-gradient(135deg, var(--bg-dark), var(--bg-darker));\n    color: var(--text);\n}\n\n\n/* Contact */\n#contact {\n    background: var(--grad-darkred);\n    background-size: 400% 400%;\n    animation: gradientAnim 12s ease infinite;\n    color: var(--text);\n}\n\nform {\n    background: #2a2a2a;\n    border-radius: 16px;\n    box-shadow: var(--shadow);\n    padding: 32px;\n    max-width: 720px;\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n/* Réalisation en pleine largeur */\n.portfolio-heading {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 24px;\n    margin-bottom: 28px;\n}\n\n.portfolio-heading .section-title {\n    margin-bottom: 8px;\n    text-align: left;\n}\n\n.portfolio-heading .section-sub {\n    margin: 0;\n    text-align: left;\n}\n\n.carousel-actions {\n    display: flex;\n    gap: 10px;\n}\n\n.carousel-button {\n    width: 48px;\n    height: 48px;\n    padding: 0;\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.08);\n    color: #fff;\n    font-size: 22px;\n    cursor: pointer;\n    transition: 0.25s ease;\n}\n\n.carousel-button:hover {\n    background: var(--accent);\n    border-color: var(--accent);\n    transform: translateY(-2px);\n}\n\n.project-page {\n    position: relative;\n    width: 100%;\n    height: 520px;\n    overflow: hidden;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 20px;\n    background: #111;\n    box-shadow: var(--shadow);\n    transform-origin: right center;\n    animation: turnProjectPage 0.9s ease both;\n}\n\n.project-page a {\n    display: block;\n    width: 100%;\n    height: 100%;\n}\n\n.project-page img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    object-position: center top;\n    background: #111;\n}\n\n.project-page-overlay {\n    position: absolute;\n    inset: 0;\n    z-index: 2;\n    display: flex;\n    align-items: flex-end;\n    padding: 36px;\n    color: #fff;\n    background: linear-gradient(\n        0deg,\n        rgba(0, 0, 0, 0.96) 0%,\n        rgba(0, 0, 0, 0.55) 35%,\n        transparent 70%\n    );\n}\n\n.project-counter {\n    position: absolute;\n    top: 24px;\n    right: 26px;\n    padding: 8px 13px;\n    border: 1px solid rgba(255, 255, 255, 0.18);\n    border-radius: 20px;\n    background: rgba(0, 0, 0, 0.7);\n    font-size: 13px;\n    font-weight: 700;\n}\n\n.project-page-content {\n    width: min(520px, 90%);\n}\n\n.project-page-content h3 {\n    margin: 0 0 12px;\n    color: #fff;\n    font-size: clamp(30px, 5vw, 52px);\n    line-height: 1.1;\n}\n\n.project-page-content p {\n    margin: 0 0 20px;\n    color: rgba(255, 255, 255, 0.85);\n    font-size: 17px;\n    line-height: 1.55;\n}\n\n.project-link {\n    font-size: 14px;\n    font-weight: 700;\n    color: var(--accent);\n}\n\n.project-dots {\n    display: flex;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 22px;\n}\n\n.project-dots button {\n    width: 10px;\n    height: 10px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.25);\n    cursor: pointer;\n    transition: 0.25s ease;\n}\n\n.project-dots button.active {\n    width: 30px;\n    border-radius: 10px;\n    background: var(--accent);\n}\n\n@keyframes turnProjectPage {\n    from {\n        opacity: 0;\n        transform: perspective(1400px) rotateY(18deg) translateX(-45px);\n        filter: brightness(0.5);\n    }\n\n    to {\n        opacity: 1;\n        transform: perspective(1400px) rotateY(0) translateX(0);\n        filter: brightness(1);\n    }\n}\n\n@media (max-width: 640px) {\n    .portfolio-heading {\n        align-items: center;\n    }\n\n    .carousel-actions {\n        display: none;\n    }\n\n    .project-page {\n        height: 460px;\n    }\n\n    .project-page-overlay {\n        padding: 24px;\n    }\n\n    .project-page-content h3 {\n        font-size: 30px;\n    }\n\n    .project-page-content p {\n        font-size: 15px;\n    }\n}\n.grid-2 {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 18px;\n}\n\n@media (max-width:640px) {\n    .grid-2 {\n        grid-template-columns: 1fr\n    }\n}\n\n.form-field {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n}\n\n.form-field input,\n.form-field textarea {\n    width: 100%;\n    padding: 14px 14px;\n    border-radius: 10px;\n    background: #1a1a1a;\n    color: #fff;\n    border: 2px solid #333;\n    outline: none;\n    transition: border-color .25s, box-shadow .25s;\n}\n\n.form-field input:focus,\n.form-field textarea:focus {\n    border-color: var(--accent);\n    box-shadow: 0 0 12px rgba(230, 57, 70, .35);\n}\n\n.form-field label {\n    position: absolute;\n    left: 12px;\n    top: 12px;\n    font-size: 14px;\n    color: #aaa;\n    pointer-events: none;\n    transition: all .18s ease;\n    background: #2a2a2a;\n    padding: 0 6px;\n    border-radius: 6px;\n}\n\n.form-field input:focus+label,\n.form-field input:not(:placeholder-shown)+label,\n.form-field textarea:focus+label,\n.form-field textarea:not(:placeholder-shown)+label {\n    top: -10px;\n    left: 8px;\n    font-size: 12px;\n    color: var(--accent);\n}\n\n.submit {\n    background: var(--accent);\n    color: #fff;\n    border: none;\n    padding: 16px;\n    border-radius: 12px;\n    font-weight: 700;\n    font-size: 16px;\n    cursor: pointer;\n    box-shadow: 0 10px 28px rgba(230, 57, 70, .35);\n    transition: transform .18s, background .25s, box-shadow .25s;\n}\n\n.submit:hover {\n    background: var(--accent-2);\n    transform: translateY(-2px);\n    box-shadow: 0 14px 40px rgba(230, 57, 70, .45);\n}\n\n.status {\n    text-align: center;\n    margin-top: 4px;\n    font-weight: 700;\n}\n\n/* Reveal */\n.reveal {\n    opacity: 0;\n    transform: translateY(26px) scale(.98);\n    transition: opacity .8s, transform .8s;\n}\n\n.reveal.visible {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n}\n\n/* Footer */\nfooter {\n    margin-top: 64px;\n    background: var(--bg-dark);\n    color: var(--text);\n    text-align: center;\n    padding: 28px 20px;\n    border-top: 1px solid rgba(255, 255, 255, .06);\n    border-radius: 14px;\n}\n\n.footer-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n    gap: 40px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.contact-btn {\n    display: inline-block;\n    background: transparent;\n    color: var(--accent);\n    text-decoration: none;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 14px 22px;\n    border: 2px solid var(--accent);\n    border-radius: 50px;\n    transition: all .3s ease;\n    margin-bottom: 16px;\n}\n\n.contact-btn:hover {\n    background: var(--accent);\n    color: #fff;\n    transform: translateY(-3px);\n    box-shadow: 0 6px 16px rgba(230, 57, 70, 0.4);\n}\n\n.footer-container h4 {\n    color: var(--accent);\n    margin-bottom: 12px;\n}\n\n.footer-nav ul {\n    list-style: none;\n    padding: 0;\n}\n\n.footer-nav li {\n    margin: 6px 0;\n}\n\n.footer-nav a,\n.footer-social a {\n    color: #f2f2f2;\n    text-decoration: none;\n    transition: color .2s;\n}\n\n.footer-nav a:hover,\n.footer-social a:hover {\n    color: var(--accent);\n}\n\n.footer-bottom {\n    text-align: center;\n    margin-top: 40px;\n    font-size: 0.9rem;\n    color: #aaa;\n}\n\n.footer-bottom a {\n    color: var(--accent);\n    text-decoration: none;\n}\n\n.footer-bottom a:hover {\n    text-decoration: underline;\n}\n\n.footer-social {\n    text-align: center;\n}\n\n.social-icons {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin: 10px 0 20px;\n}\n\n.social-icons a {\n    color: var(--accent);\n    font-size: 28px;\n    transition: transform .2s, color .3s;\n}\n\n.social-icons a:hover {\n    color: var(--accent-2);\n    transform: scale(1.2);\n}\n\n.social-icons svg {\n    width: 28px;\n    height: 28px;\n}\n\n/* Animations */\n@keyframes gradientAnim {\n    0% {\n        background-position: 0% 50%\n    }\n\n    50% {\n        background-position: 100% 50%\n    }\n\n    100% {\n        background-position: 0% 50%\n    }\n}\n\n@keyframes blink {\n\n    0%,\n    50% {\n        opacity: 1\n    }\n\n    50.01%,\n    100% {\n        opacity: 0\n    }\n}\n\n@keyframes rise {\n    from {\n        transform: translateY(0) scale(1);\n        opacity: 1\n    }\n\n    to {\n        transform: translateY(-100vh) scale(.5);\n        opacity: 0\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
